"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeBit = void 0;
const BasicFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/BasicFieldType/BasicFieldType"));
const QueryFieldKey_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldKey"));
const formQuestionsToFormWithTree_1 = __importDefault(require("@opsbase/lib-form/convert/formQuestionsToFormWithTree"));
const getFilterableQuestions_1 = __importDefault(require("@opsbase/lib-form/helpers/getFilterableQuestions"));
const getFromStringOrFunction_1 = require("@opsbase/lib-general/utils/getFromStringOrFunction");
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const WorkflowMetaModelRegistry_1 = __importDefault(require("@opsbase/lib-workflow/workflow-metamodel/WorkflowMetaModelRegistry"));
const WorkflowCondition_1 = require("@opsbase/lib-workflow/WorkflowCondition");
const OperatorType_1 = __importStar(require("@opsbase/lib-workflow/WorkflowCondition/OperatorType"));
const operatorTypesFor_1 = require("@opsbase/lib-workflow/WorkflowCondition/operatorTypesFor");
const useOpDefinitionFindById_1 = __importDefault(require("@opsbase/react-gql-hooks/opdefinition/useOpDefinitionFindById"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const react_markdown_1 = require("@opsbase/react-markdown");
const web_css_1 = require("@opsbase/web-css");
const Divider_1 = __importDefault(require("@opsbase/web-layout/Divider"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal/Horizontal"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical/Vertical"));
const TextFieldWithStateAndBlur_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithStateAndBlur/TextFieldWithStateAndBlur"));
const Accordion_1 = __importDefault(require("@opsbase/web-ui/Accordion"));
const AccordionDetails_1 = __importDefault(require("@opsbase/web-ui/AccordionDetails"));
const AccordionSummary_1 = __importDefault(require("@opsbase/web-ui/AccordionSummary"));
const MenuItem_1 = __importDefault(require("@opsbase/web-ui/MenuItem/MenuItem"));
const Radio_1 = __importDefault(require("@opsbase/web-ui/Radio/Radio"));
const RadioGroup_1 = __importDefault(require("@opsbase/web-ui/RadioGroup"));
const Select_1 = __importDefault(require("@opsbase/web-ui/Select"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const Tooltip_1 = require("@opsbase/web-ui/Tooltip");
const react_1 = __importStar(require("react"));
const ConditionPicker_1 = __importDefault(require("./ConditionPicker"));
const makeMyClasses = () => ({
    hlite: {
        color: lib_palette_1.default.secondary.main,
    },
    olite: {
        color: lib_palette_1.default.warning.main,
    },
    rangetipped: {
        color: lib_palette_1.default.primary.main,
        padding: '0 4px',
    },
    booleanText: {
        color: lib_palette_1.default.GreyBlue.main,
        padding: '0 8px 0 8px',
    },
});
function WorkflowConditionPicker(props) {
    var _a, _b, _c, _d, _e, _f;
    const { disabled, expanded, onExpand, event, c, opDefinitionId, answerCondition, onChangeOperatorSelection, onChangeAnswerOperatorSelection, onChangeQueryFieldSelection, onChangeValue, onChangeAnswerValue, } = props;
    const keys = WorkflowMetaModelRegistry_1.default[event];
    const queryFields = keys === null || keys === void 0 ? void 0 : keys.queryFields;
    const operators = (0, operatorTypesFor_1.operatorTypesForField)(queryFields === null || queryFields === void 0 ? void 0 : queryFields.find(p => p.key === (c === null || c === void 0 ? void 0 : c.queryFieldKey)));
    const { data: opDefinition } = (0, useOpDefinitionFindById_1.default)({
        variables: { id: opDefinitionId },
        skip: !opDefinitionId || c.queryFieldKey !== QueryFieldKey_1.default.OP_QUESTION,
    });
    let questions = [];
    let rule;
    let question;
    let answerOperators = [];
    if (opDefinition) {
        let parsedForm = (0, formQuestionsToFormWithTree_1.default)(opDefinition === null || opDefinition === void 0 ? void 0 : opDefinition.form);
        questions = (0, getFilterableQuestions_1.default)(parsedForm === null || parsedForm === void 0 ? void 0 : parsedForm.questionTree);
        const value = (_c = (_b = (_a = c === null || c === void 0 ? void 0 : c.value) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.split('_');
        rule = (_d = parsedForm === null || parsedForm === void 0 ? void 0 : parsedForm.rules) === null || _d === void 0 ? void 0 : _d[value === null || value === void 0 ? void 0 : value[(value === null || value === void 0 ? void 0 : value.length) - 1]];
        question = questions === null || questions === void 0 ? void 0 : questions.find(q => { var _a, _b; return q.nodeId === ((_b = (_a = c === null || c === void 0 ? void 0 : c.value) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b[0]); });
        answerOperators = (0, operatorTypesFor_1.operatorTypesForQuestionType)(question === null || question === void 0 ? void 0 : question.type);
    }
    const myCss = (0, web_css_1.useCss)(makeMyClasses);
    const handleQueryFieldSelection = (0, react_1.useCallback)(key => {
        onChangeQueryFieldSelection(key);
    }, [onChangeQueryFieldSelection]);
    const handleOperatorSelection = (0, react_1.useCallback)(operator => {
        onChangeOperatorSelection(operator);
    }, [onChangeOperatorSelection]);
    const handleAnswerOperatorSelection = (0, react_1.useCallback)(operator => {
        onChangeAnswerOperatorSelection(operator);
    }, [onChangeAnswerOperatorSelection]);
    const handleChange = (0, useCallforward_1.default)(property => (v) => {
        // value[property] = value?.toString()
        onChangeValue(new WorkflowCondition_1.QueryFieldValue(Object.assign(Object.assign({}, c === null || c === void 0 ? void 0 : c.value), { [property]: v })));
    }, [c, onChangeValue]);
    const qfKey = c === null || c === void 0 ? void 0 : c.queryFieldKey;
    const label = (0, react_1.useMemo)(() => { var _a; return (0, getFromStringOrFunction_1.getFromStringOrFunction)((_a = queryFields === null || queryFields === void 0 ? void 0 : queryFields.find(q => q.key === qfKey)) === null || _a === void 0 ? void 0 : _a.label); }, [qfKey, queryFields]);
    const repeatingEvent = (0, react_1.useMemo)(() => [
        QueryFieldKey_1.default.ASSET_SENSOR_OBJECT_PRESENT,
        QueryFieldKey_1.default.ASSET_SENSOR_WATER_PRESENT,
        QueryFieldKey_1.default.ASSET_SENSOR_HUMIDITY,
        QueryFieldKey_1.default.ASSET_SENSOR_TEMPERATURE,
    ].find(f => f === qfKey), [qfKey]);
    const lastTitleIndex = ((_f = (_e = c === null || c === void 0 ? void 0 : c.value) === null || _e === void 0 ? void 0 : _e.title) === null || _f === void 0 ? void 0 : _f.length) - 1;
    const value = c === null || c === void 0 ? void 0 : c.value;
    const summaryOperandStrings = (0, react_1.useMemo)(() => {
        var _a;
        const strings = [];
        const v = value;
        if (v) {
            if (v.from)
                strings.push(v.from);
            if (v.to) {
                strings.push(lib_i18n_1.default.t('and'));
                strings.push(v.to);
            }
            if ((_a = v.title) === null || _a === void 0 ? void 0 : _a.length) {
                v.title.forEach((t, i) => {
                    strings.push(t);
                    if (i !== lastTitleIndex)
                        strings.push(lib_i18n_1.default.t('or'));
                });
            }
            if (qfKey === QueryFieldKey_1.default.ASSET_LASTSERVICEDATE && v.valueUnit) {
                strings.push(getLabel(v.valueUnit));
            }
        }
        return strings;
    }, [lastTitleIndex, qfKey, value]);
    return (react_1.default.createElement(Accordion_1.default, { disabled: disabled, expanded: disabled ? false : expanded, onChange: disabled ? undefined : onExpand },
        react_1.default.createElement(AccordionSummary_1.default, null,
            react_1.default.createElement(Horizontal_1.default, { gutter: true, justify: 'flex-start', centered: true },
                react_1.default.createElement(Text_1.default, null,
                    (label || '') + ' ',
                    react_1.default.createElement("span", { className: myCss.olite }, (c === null || c === void 0 ? void 0 : c.operator) && !expanded ? (0, OperatorType_1.operatorTypeLabel)(c === null || c === void 0 ? void 0 : c.operator) : ''),
                    react_1.default.createElement("span", null, " "),
                    !expanded &&
                        summaryOperandStrings.map((z, i) => {
                            if (i % 2 === 0) {
                                return react_1.default.createElement("span", { className: myCss.hlite }, z);
                            }
                            return react_1.default.createElement("span", { className: myCss.booleanText }, z);
                        })))),
        react_1.default.createElement(AccordionDetails_1.default, null, !disabled && (react_1.default.createElement(Vertical_1.default, { gutter: true },
            react_1.default.createElement(Horizontal_1.default, { gutter: true, justify: 'flex-start' },
                react_1.default.createElement(Select_1.default, { value: c === null || c === void 0 ? void 0 : c.queryFieldKey, onChange: handleQueryFieldSelection, placeholder: lib_i18n_1.default.t('choose-field') }, queryFields === null || queryFields === void 0 ? void 0 : queryFields.map(p => (react_1.default.createElement(MenuItem_1.default, { key: p.key, value: p.key },
                    react_1.default.createElement(Text_1.default, null, (0, getFromStringOrFunction_1.getFromStringOrFunction)(p.label)))))),
                !!(operators === null || operators === void 0 ? void 0 : operators.length) && (react_1.default.createElement(Select_1.default, { value: c === null || c === void 0 ? void 0 : c.operator, onChange: handleOperatorSelection, placeholder: lib_i18n_1.default.t('choose-operator') }, operators === null || operators === void 0 ? void 0 : operators.map(createOperatorMenuItem))),
                (c === null || c === void 0 ? void 0 : c.operator) !== OperatorType_1.default.IS_EMPTY &&
                    (c === null || c === void 0 ? void 0 : c.operator) !== OperatorType_1.default.IS_TRUE &&
                    (c === null || c === void 0 ? void 0 : c.operator) !== OperatorType_1.default.IS_NOT_TRUE &&
                    keys &&
                    (c === null || c === void 0 ? void 0 : c.queryFieldKey) &&
                    (c === null || c === void 0 ? void 0 : c.operator) && (react_1.default.createElement(ConditionPicker_1.default, { queryField: queryFields === null || queryFields === void 0 ? void 0 : queryFields.find(k => k.key === (c === null || c === void 0 ? void 0 : c.queryFieldKey)), value: c === null || c === void 0 ? void 0 : c.value, operator: c === null || c === void 0 ? void 0 : c.operator, onChangeValue: onChangeValue, options: questions.map(q => {
                        q.title =
                            (q.repetitionIndex >= 0
                                ? q.repetitionIndex + 1 + ':'
                                : '') + q.title;
                        return q;
                    }) }))),
            (c === null || c === void 0 ? void 0 : c.queryFieldKey) === QueryFieldKey_1.default.OP_QUESTION && (react_1.default.createElement(Horizontal_1.default, { gutter: true, justify: 'flex-start' },
                react_1.default.createElement(Select_1.default, { value: answerCondition.queryFieldKey, disabled: true, style: { width: 105 } },
                    react_1.default.createElement(MenuItem_1.default, { key: answerCondition.queryFieldKey, value: answerCondition.queryFieldKey },
                        react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('answer')))),
                react_1.default.createElement(Select_1.default, { value: answerCondition.operator, onChange: handleAnswerOperatorSelection }, answerOperators === null || answerOperators === void 0 ? void 0 : answerOperators.map(createOperatorMenuItem)),
                react_1.default.createElement(ConditionPicker_1.default, { queryField: {
                        key: QueryFieldKey_1.default.OP_ANSWER,
                        fieldType: BasicFieldType_1.default.STRING,
                        label: lib_i18n_1.default.t('answer'),
                    }, value: answerCondition === null || answerCondition === void 0 ? void 0 : answerCondition.value, operator: answerCondition === null || answerCondition === void 0 ? void 0 : answerCondition.operator, onChangeValue: onChangeAnswerValue, type: question === null || question === void 0 ? void 0 : question.type, rule: rule }))),
            repeatingEvent && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Divider_1.default, null),
                react_1.default.createElement(Delay, { label: label, c: c, handleChange: handleChange }),
                react_1.default.createElement(Divider_1.default, null),
                react_1.default.createElement(Repetition, { c: c, handleChange: handleChange }),
                react_1.default.createElement(Divider_1.default, null),
                react_1.default.createElement(Cooldown, { label: label, c: c, handleChange: handleChange }))))))));
}
exports.default = WorkflowConditionPicker;
function Delay({ label, c, handleChange }) {
    var _a, _b;
    const myCss = (0, web_css_1.useCss)(makeMyClasses);
    return (react_1.default.createElement(Text_1.default, null,
        react_1.default.createElement("span", null, (0, react_markdown_1.markdown)(lib_i18n_1.default.t('delay-desc-prefix1'))),
        react_1.default.createElement(Tooltip_1.Tooltip, { noInnerDiv: true, tip: (0, react_markdown_1.markdown)(lib_i18n_1.default.t('sensor-workflow-note', { conditionText: getConditionText(label, c) })) },
            react_1.default.createElement("span", { className: myCss.rangetipped }, (0, react_markdown_1.markdown)(lib_i18n_1.default.t('delay-desc-prefix2')))),
        react_1.default.createElement("span", null, (0, react_markdown_1.markdown)(lib_i18n_1.default.t('delay-desc-prefix3'))),
        react_1.default.createElement(TimeBit, { value: (_a = c === null || c === void 0 ? void 0 : c.value) === null || _a === void 0 ? void 0 : _a.delay, onChangeValue: handleChange('delay'), unit: (_b = c === null || c === void 0 ? void 0 : c.value) === null || _b === void 0 ? void 0 : _b.delayUnit, onChangeUnit: handleChange('delayUnit'), padTop: true }),
        (0, react_markdown_1.markdown)(lib_i18n_1.default.t('delay-desc-suffix'))));
}
function Repetition({ c, handleChange }) {
    var _a, _b, _c, _d;
    const repeatOnce = ((_a = c === null || c === void 0 ? void 0 : c.value) === null || _a === void 0 ? void 0 : _a.repetition) === 0;
    const handleChangeRepeatOnce = (0, react_1.useCallback)(v => {
        handleChange('repetition')(v === 'repeatOnce' ? 0 : 1);
    }, [handleChange]);
    return (react_1.default.createElement(RadioGroup_1.default, { value: repeatOnce ? 'repeatOnce' : 'duration', onChange: handleChangeRepeatOnce },
        react_1.default.createElement(Vertical_1.default, null,
            react_1.default.createElement(Text_1.default, null, (0, react_markdown_1.markdown)(lib_i18n_1.default.t('repeat-once-prefix'))),
            react_1.default.createElement(Horizontal_1.default, { justify: "flex-start", gutter: true, centered: true },
                react_1.default.createElement(Radio_1.default, { value: "repeatOnce", checked: repeatOnce }),
                react_1.default.createElement(Text_1.default, { color: repeatOnce ? undefined : 'lightgrey' }, (0, react_markdown_1.markdown)(lib_i18n_1.default.t('repeat-once')))),
            react_1.default.createElement(Horizontal_1.default, { justify: "flex-start", gutter: true, centered: true },
                react_1.default.createElement(Radio_1.default, { value: "duration", checked: ((_b = c === null || c === void 0 ? void 0 : c.value) === null || _b === void 0 ? void 0 : _b.repetition) !== 0 }),
                react_1.default.createElement(Text_1.default, { color: repeatOnce ? 'lightgrey' : undefined },
                    (0, react_markdown_1.markdown)(lib_i18n_1.default.t('repeat-every-prefix')),
                    react_1.default.createElement(TimeBit, { disabled: repeatOnce, value: ((_c = c === null || c === void 0 ? void 0 : c.value) === null || _c === void 0 ? void 0 : _c.repetition) || 1, onChangeValue: handleChange('repetition'), unit: (_d = c === null || c === void 0 ? void 0 : c.value) === null || _d === void 0 ? void 0 : _d.repetitionUnit, onChangeUnit: handleChange('repetitionUnit'), padTop: true }))))));
}
function Cooldown({ label, c, handleChange }) {
    var _a, _b;
    const myCss = (0, web_css_1.useCss)(makeMyClasses);
    return (react_1.default.createElement(Text_1.default, null,
        react_1.default.createElement("span", null, (0, react_markdown_1.markdown)(lib_i18n_1.default.t('cooldown-prefix1'))),
        react_1.default.createElement(Tooltip_1.Tooltip, { noInnerDiv: true, tip: (0, react_markdown_1.markdown)(lib_i18n_1.default.t('sensor-workflow-note', { conditionText: getConditionText(label, c) })) },
            react_1.default.createElement("span", { className: myCss.rangetipped }, (0, react_markdown_1.markdown)(lib_i18n_1.default.t('cooldown-prefix2')))),
        react_1.default.createElement("span", null, (0, react_markdown_1.markdown)(lib_i18n_1.default.t('cooldown-prefix3'))),
        react_1.default.createElement(TimeBit, { value: (_a = c === null || c === void 0 ? void 0 : c.value) === null || _a === void 0 ? void 0 : _a.cooldown, onChangeValue: handleChange('cooldown'), unit: (_b = c === null || c === void 0 ? void 0 : c.value) === null || _b === void 0 ? void 0 : _b.cooldownUnit, onChangeUnit: handleChange('cooldownUnit'), padTop: true }),
        (0, react_markdown_1.markdown)(lib_i18n_1.default.t('cooldown-suffix'))));
}
function TimeBit(props) {
    const { disabled = false, value, onChangeValue, unit, onChangeUnit, padTop = false, items = ['minute', 'hour', 'day'], } = props;
    const inputProps = (0, react_1.useMemo)(() => ({
        style: {
            paddingLeft: 4,
            paddingRight: 4,
            paddingTop: padTop ? 4 : undefined,
            paddingBottom: padTop ? 4 : undefined,
            textAlign: 'center',
        },
    }), []);
    const InputProps = (0, react_1.useMemo)(() => ({
        style: { width: 40, margin: '2px 4px' },
    }), []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { disabled: disabled, InputProps: InputProps, inputProps: inputProps, noMargin: true, type: 'number', value: value, onBlur: onChangeValue }),
        react_1.default.createElement(Select_1.default, { style: { marginRight: 4 }, disabled: disabled, noMargin: true, noBorder: true, value: unit, onChange: onChangeUnit, white: true }, items.map(i => (react_1.default.createElement(MenuItem_1.default, { value: i, key: i },
            react_1.default.createElement(Text_1.default, null, getLabel(i))))))));
}
exports.TimeBit = TimeBit;
function getLabel(key) {
    switch (key) {
        case 'day':
            return lib_i18n_1.default.t('days');
        case 'month':
            return lib_i18n_1.default.t('months');
        case 'year':
            return lib_i18n_1.default.t('years');
        case 'minute':
            return lib_i18n_1.default.t('minutes');
        case 'hour':
            return lib_i18n_1.default.t('hours');
    }
}
function getConditionText(label, c) {
    var _a, _b, _c, _d, _e, _f;
    return (label +
        ' ' +
        (0, OperatorType_1.operatorTypeLabel)(c === null || c === void 0 ? void 0 : c.operator) +
        (((_a = c === null || c === void 0 ? void 0 : c.value) === null || _a === void 0 ? void 0 : _a.from) ? ' ' + ((_b = c === null || c === void 0 ? void 0 : c.value) === null || _b === void 0 ? void 0 : _b.from) : '') +
        (((_c = c === null || c === void 0 ? void 0 : c.value) === null || _c === void 0 ? void 0 : _c.to) ? ' ' + ((_d = c === null || c === void 0 ? void 0 : c.value) === null || _d === void 0 ? void 0 : _d.to) : '') +
        (((_e = c === null || c === void 0 ? void 0 : c.value) === null || _e === void 0 ? void 0 : _e.title) ? ' ' + ((_f = c === null || c === void 0 ? void 0 : c.value) === null || _f === void 0 ? void 0 : _f.title) : ''));
}
function createOperatorMenuItem(o) {
    return (react_1.default.createElement(MenuItem_1.default, { key: o, value: o },
        react_1.default.createElement(Text_1.default, null, (0, OperatorType_1.operatorTypeLabel)(o))));
}
